export const ALERT_TYPES = {
    POINTS_SCORED: 'points_scored',
    DAILY_GOAL: 'daily_goal',
    MONTHLY_GOAL: 'monthly_goal',
    MONTHLY_GOAL_MAIN: 'monthly_goal_animation',
    RANK: 'new_rank',
}